import { traktoMiddleware } from './trakto/trakto';
import { mobeesMiddleware } from './mobees/mobees';

export const partnershipsMiddlewares = [
    traktoMiddleware,
    mobeesMiddleware,
];
